import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ApiShowResponse } from '@/common/types/requests'
import { MaintenanceEquipmentPieceData } from '@/features/maintenance/features/workflows/types/maintenanceEquipmentPiece.type'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'

type UseMaintenanceEquipmentPieceProps = {
  equipmentId: string | undefined
  pieceId: string | undefined
  options?: Partial<
    UseQueryOptions<ApiShowResponse<MaintenanceEquipmentPieceData>, unknown, MaintenanceEquipmentPieceData>
  >
}

export const useMaintenanceEquipmentPiece = ({ equipmentId, pieceId, options }: UseMaintenanceEquipmentPieceProps) => {
  const privateAxios = usePrivateAxios()

  return useQuery<ApiShowResponse<MaintenanceEquipmentPieceData>, unknown, MaintenanceEquipmentPieceData>({
    enabled: !!equipmentId && !!pieceId,
    queryKey: ['maintenanceEquipmentPiece', equipmentId, pieceId],
    queryFn: () => privateAxios.get(`/client/equipments/${equipmentId}/maintenance_pieces/${pieceId}`),
    select: (data) => data?.data?.data,
    ...options,
  })
}
